import { useContext } from 'react';
import { ServiceContext } from 'providers/ServiceProvider';

export const useActiveService = () => {
  const [activeService, setActiveService, services, loading] = useContext(ServiceContext);
  return { activeService, setActiveService, services, loading, activeServiceLoaded: Boolean(activeService) };
};
